import { useTranslation } from 'react-i18next';

const certKeys = [
  { icon: 'ri-award-line', labelKey: 'brand_cert1_label', subKey: 'brand_cert1_sub' },
  { icon: 'ri-leaf-line', labelKey: 'brand_cert2_label', subKey: 'brand_cert2_sub' },
  { icon: 'ri-global-line', labelKey: 'brand_cert3_label', subKey: 'brand_cert3_sub' },
  { icon: 'ri-heart-line', labelKey: 'brand_cert4_label', subKey: 'brand_cert4_sub' },
];

export default function BrandSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-br from-[#3d2314] to-[#5c3520] py-20 md:py-28 px-6 md:px-10 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6 max-w-2xl">
          {t('brand_title1')}
          <br />
          {t('brand_title2')}
        </h2>

        <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-xl mb-12">
          {t('brand_desc')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20pet%20product%20factory%20interior%2C%20workers%20crafting%20cat%20scratching%20boards%2C%20clean%20production%20line%2C%20warm%20industrial%20lighting%2C%20professional%20manufacturing%20environment%2C%20high%20quality%20craftsmanship%2C%20natural%20materials%20processing&width=600&height=450&seq=brand1&orientation=landscape"
              alt="Koorpet Factory"
              className="w-full h-64 md:h-80 object-cover object-top"
            />
          </div>

          <div className="flex flex-col gap-8">
            <div>
              <div className="text-6xl md:text-8xl font-bold text-white leading-none">{t('brand_years_num')}</div>
              <div className="text-[#f5c9a8] text-lg mt-2">{t('brand_years_label')}</div>
              <p className="text-white/55 text-sm mt-3 leading-relaxed">
                {t('brand_years_desc')}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {certKeys.map((item) => (
                <div key={item.labelKey} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#C8714A]/30 flex-shrink-0">
                    <i className={`${item.icon} text-[#f5c9a8] text-sm`}></i>
                  </div>
                  <div>
                    <div className="text-white text-sm font-semibold">{t(item.labelKey)}</div>
                    <div className="text-white/50 text-xs mt-0.5">{t(item.subKey)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}